module.exports = __webpack_public_path__ + "img/kerala-forest-department-logo.a9bde176.png";